<template>
  <el-tooltip
    class="w-100"
    :content="placeholder"
    placement="top"
    effect="light"
    :open-delay="300"
    transition="el-zoom-in-top"
  >
    <el-select
      ref="infinite-dropdown"
      v-model="filter"
      :placeholder="filterPlaceholder"
      :name="`search-${fieldName}`"
      :multiple="!!field.multiple"
      :no-data-text="noDataText"
      :no-match-text="noDataText"
      clearable
      collapse-tags
      filterable
      remote
      :remote-method="filterOptions"
      @change="onChange"
      @visible-change="onVisibleChange"
    >
      <el-option
        v-for="{ key, value } in filteredOptions"
        :key="`search-${fieldName}-${key}`"
        :label="value"
        :value="key"
      />
      <loader class="h-25" v-if="optionLoader" />
    </el-select>
  </el-tooltip>
</template>

<script>
import { get, isEmpty, isEqual, isFunction } from 'lodash'
import { createStorage } from '../../../utils'
import Loader from '../../Loader.vue'
import dropdownMixin from '../../../utils/mixin-dropdown'

export default {
  name: 'FilterSelect',
  components: {
    Loader,
  },
  mixins: [dropdownMixin],
  props: {
    field: {
      type: Object,
      required: true,
    },
    panelId: {
      type: String,
    },
  },
  data() {
    return {
      dynamicOptions: [],
      localStore: {},
      loading: false,
      isFilter: true,
    }
  },
  computed: {
    filter: {
      get() {
        return this.$get('columnFilter')(this.fieldName, [])
      },
      set(filter) {
        this.$dispatch('setFilter', { data: this.fieldName, filter })
      },
    },
    storageKey() {
      return this.$get('storageKey')
    },
    filterPlaceholder() {
      if (this.query || this.filter) return ''
      return this.placeholder
    },
    hasValue() {
      return !isEmpty(String(this.filter))
    },
    mongoId() {
      return this.$get('mongoId')
    },
    prefix() {
      switch (this.filter) {
        case 0:
          return `<span class="material-icons md-18">check_box_outline_blank</span>`
        case 1:
          return `<span class="material-icons md-18">check_box</span>`
        default:
          return `<span class="material-icons md-18"></span>`
      }
    },
  },
  methods: {
    onChange() {
      this.$emit('apply-filter')
      this.$dispatch('setSearchTrigger', { searchTrigger: 'filter' })
    },
    preventLazyLoad() {
      if (get(this.list, 'completed', false) && this.lastRequestQuery === '') this.initial = false
    },
  },
  created() {
    const panelIndex = this.panelId ? get(this.panelId.match(/\d+$/), '0', 0) : this.mongoId || this.getRawSqlId
    this.localStore = createStorage(this.storageKey, { id: panelIndex })
    // @TODO dropdown:mongo fejlesztes utan kivenni
    this.preventLazyLoad()
  },
  watch: {
    filter: {
      handler(newValue, oldValue) {
        if (isEqual(newValue, oldValue)) return
        if (this.completed) return
        if (this.isNarrowDown(newValue) || oldValue === false || newValue === false) return
        this.debouncedDataFetch()
      },
    },
  }
}
</script>

<style lang="scss" scoped>
.color-primary {
  color: $color-text-primary;
}
</style>
